module.exports = "<div class=\"sun-app-contents\">\r\n  <div class=\"sun-list-single-container\">\r\n    <ul>\r\n        <li *ngFor=\"let sentReport of sentReports; let i = index;\">\r\n          <a (click)=\"report(sentReport)\">\r\n            <p class=\"sun-text\">{{sentReport.storeName}}</p>\r\n            <p class=\"sun-date\">{{sentReport.formattedDeliveryDate}}</p>\r\n            <i class=\"sun-icon-arrow_right_m\"></i>\r\n          </a>\r\n        </li>\r\n    </ul>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/kvap0400/kvap0400.component.html
// module id = ./src/app/component/kvap0400/kvap0400.component.html
// module chunks = main